export enum Envs {
    MOCK = 'mock',
    LOCAL = 'local',
    DEV = 'dev',
    SIT = 'sit',
    UAT = 'uat',
    PT = 'pt',
    OAT = 'oat',
    STAGING = 'staging',
    PROD = 'prod',
}
